'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_style2.default);

var Step = function Step(_ref) {
  var label = _ref.label,
      number = _ref.number,
      isActive = _ref.isActive,
      _ref$isInteractive = _ref.isInteractive,
      isInteractive = _ref$isInteractive === undefined ? false : _ref$isInteractive,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {
    return void 0;
  } : _ref$onClick;
  return _react2.default.createElement(
    'div',
    {
      className: cx('xsui-step-tabs__item', isActive && 'xsui-step-tabs__item--active', disabled && 'xsui-step-tabs__item--disabled', isInteractive && 'xsui-step-tabs__item--interactive'),
      onClick: isInteractive ? onClick : function () {
        return void 0;
      } },
    _react2.default.createElement(
      'div',
      { className: cx('xsui-step-tabs__item__number') },
      number
    ),
    _react2.default.createElement(
      'div',
      { className: cx('xsui-step-tabs__item__label') },
      label
    )
  );
};

Step.propTypes = {
  label: _propTypes2.default.string.isRequired,
  isInteractive: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  number: _propTypes2.default.number.isRequired,
  isActive: _propTypes2.default.bool.isRequired
};
var StepTabs = function StepTabs(_ref2) {
  var current = _ref2.current,
      steps = _ref2.steps,
      _ref2$isInteractive = _ref2.isInteractive,
      isInteractive = _ref2$isInteractive === undefined ? false : _ref2$isInteractive;

  var extendedSteps = steps.map(function (step, index) {
    return _extends({}, step, {
      number: index + 1,
      isActive: !step.disabled && current >= index + 1,
      isInteractive: isInteractive
    });
  });

  return _react2.default.createElement(
    'div',
    { className: cx('xsui-step-tabs') },
    extendedSteps.map(function (step, index) {
      return _react2.default.createElement(Step, _extends({}, step, { key: 'xsui-step---' + index }));
    })
  );
};

StepTabs.propTypes = {
  current: _propTypes2.default.number.isRequired,
  steps: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    isInteractive: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    onClick: _propTypes2.default.func
  }).isRequired).isRequired,
  isInteractive: _propTypes2.default.bool
};
exports.default = StepTabs;